import { HFlow, VFlow } from 'bold-ui'
import { DecimalField, ErrorField, resolveName } from 'components/form'
import { getFieldError } from 'components/form/core/util'
import React, { ReactElement } from 'react'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { UnidadeForcaMuscularSelectField, UnidadeForcaMuscularSelectModel } from './UnidadeForcaMuscularSelectField'

interface ForcaMuscularMaoFieldProps {
  name: {
    valor: MetaPath<string>
    unidade: MetaPath<UnidadeForcaMuscularSelectModel>
  }
  label: {
    valor: ReactElement | string
    unidade: ReactElement | string
  }
}

export function ForcaMuscularMaoField(props: Readonly<ForcaMuscularMaoFieldProps>) {
  const { name, label } = props

  const { meta: metaValor } = useField<string>(resolveName(name.valor), {
    subscription: { error: true, touched: true, submitError: true, dirtySinceLastSubmit: true },
  })
  const { meta: metaUnidade } = useField<UnidadeForcaMuscularSelectModel>(resolveName(name.unidade), {
    subscription: { error: true, touched: true, submitError: true, dirtySinceLastSubmit: true },
  })

  return (
    <VFlow vSpacing={0.5}>
      <HFlow hSpacing={0.5}>
        <DecimalField
          name={name.valor}
          label={label.valor}
          placeholder='0 a 100'
          precisao={1}
          error={null}
          invalid={getFieldError(metaValor)}
        />
        <UnidadeForcaMuscularSelectField
          name={name.unidade}
          label={label.unidade}
          placeholder='Unidade de força'
          error={null}
          invalid={getFieldError(metaUnidade)}
        />
      </HFlow>
      <ErrorField name={name.valor} />
      <ErrorField name={name.unidade} />
    </VFlow>
  )
}
